import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { Tooltip } from 'primeng/tooltip';
import {
  Consumable,
  ConsumableSelection,
  ConsumableUnit,
  consumableUnitLabel,
} from '../../../models/consumable.model';
interface ConsumableDraft {
  consumable_id: number;
  name: string;
  cost: string;
  unit: ConsumableUnit | null;
  description: string;
  quantity: number;
}

@Component({
  selector: 'app-item-consumables-editor',
  imports: [
    Button,
    CurrencyPipe,
    Dialog,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    InputTextModule,
    Tooltip,
  ],
  templateUrl: './item-consumables-editor.component.html',
  host: {
    class: 'relative z-10 inline-flex items-center',
  },
})
export class ItemConsumablesEditorComponent {
  @Input() catalog: Consumable[] = [];
  @Input() selected: ConsumableSelection[] = [];
  @Input() currencyCode = 'GBP';
  @Output() selectedChange = new EventEmitter<ConsumableSelection[]>();

  readonly unitLabel = consumableUnitLabel;

  visible = false;
  searchQuery = '';
  draft: ConsumableDraft[] = [];

  get count(): number {
    return this.selected.length;
  }

  open(): void {
    const catalogById = new Map(this.catalog.map((row) => [row.id, row]));
    this.draft = this.selected.map((selection) => {
      const consumable = catalogById.get(selection.consumable_id);
      return {
        consumable_id: selection.consumable_id,
        name: consumable?.name ?? `Consumable ${selection.consumable_id}`,
        cost: consumable?.cost ?? '0.00',
        unit: consumable?.unit ?? null,
        description: consumable?.description ?? '',
        quantity: Number(selection.quantity),
      };
    });
    this.searchQuery = '';
    this.visible = true;
  }

  get searchResults(): Consumable[] {
    const selectedIds = new Set(this.draft.map((row) => row.consumable_id));
    const needle = this.searchQuery.trim().toLowerCase();
    return this.catalog.filter(
      (row) =>
        !row.is_archived &&
        !selectedIds.has(row.id) &&
        `${row.name} ${row.description}`.toLowerCase().includes(needle),
    );
  }

  add(consumable: Consumable): void {
    this.draft = [
      ...this.draft,
      {
        consumable_id: consumable.id,
        name: consumable.name,
        cost: consumable.cost,
        unit: consumable.unit,
        description: consumable.description,
        quantity: 1,
      },
    ];
  }

  remove(consumableId: number): void {
    this.draft = this.draft.filter((row) => row.consumable_id !== consumableId);
  }

  save(): void {
    this.selectedChange.emit(
      this.draft.map((row) => ({
        consumable_id: row.consumable_id,
        quantity: String(row.quantity),
      })),
    );
    this.visible = false;
  }
}
